import { AbstractControl, FormArray, ValidatorFn } from '@angular/forms';
import { TRUE } from './typescript.constants';

export type FormModel<T> = Partial<Record<keyof T, any>>;

export class FormHelper {
  /**
   * Patches form control, taking all fields existing both in form and data
   * @param form    form to patch
   * @param data    data source
   * @param options additional parameters
   */
  public static patch(
    form: AbstractControl,
    data: any,
    options?: {
      onlySelf?: boolean;
      emitEvent?: boolean;
      emitModelToViewChange?: boolean;
      emitViewToModelChange?: boolean;
    }
  ): void {
    const value: any = {};
    if (!data) return;
    // prettier-ignore
    Object.keys(form.value).forEach((key) => { if (data.hasOwnProperty(key)) value[key] = data[key]; });
    form.patchValue(value, options);
  }

  public static patchArray(
    form: FormArray,
    data: any[],
    crateFormFunc: () => AbstractControl,
    clear = true,
    options?: {
      onlySelf?: boolean;
      emitEvent?: boolean;
      emitModelToViewChange?: boolean;
      emitViewToModelChange?: boolean;
    }
  ): void {
    if (clear) form.clear();
    const offset = form.length;

    data?.forEach((x, i) => {
      form.push(crateFormFunc());
      FormHelper.patch(form.at(i + offset), x, options);
    });
  }

  // FIXME: double ternary
  public static setValidators(ctrl: AbstractControl | null, validators: ValidatorFn | ValidatorFn[] | null | undefined): void {
    if (ctrl) {
      if (validators) ctrl.setValidators(validators);
      else ctrl.clearValidators();
      ctrl.updateValueAndValidity();
    }
  }

  /**
   * Check validity of array of controls
   * @param {AbstractControl[]} controls
   * @return {boolean} if all controls are valid
   */
  public static checkValidity(...controls: AbstractControl[]): boolean {
    return controls.reduce((valid, ctrl) => {
      ctrl.markAllAsTouched();
      return valid && ctrl.valid;
    }, TRUE);
  }

  /**
   * Check dirtiness of array of controls
   * @param {AbstractControl[]} controls
   * @return {boolean} if any of the controls is dirty
   */
  public static checkDirtiness(...controls: AbstractControl[]): boolean {
    return controls.reduce((dirty, ctrl) => dirty || ctrl.dirty, TRUE);
  }
}
